// extracted by mini-css-extract-plugin
export default {"converterLabel":"converter_converterLabel__mH9z8","titleSection":"converter_titleSection__xNIpD","formulaSection":"converter_formulaSection__XAHj6","page":"converter_page__JL0cu"};